import React from "react";
import { Card } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { Due, Item } from "../common";
import NoOrder from "./NoOrder";
import "../App.css";

interface ItemSectionProps {
  dues: Due[];
  items: Item[];
  removeItem: (index: number) => void;
}

// Local helper to pretty print an item's data
const formatItem = (item: Item): string =>
  `${item.text} - $${item.price.toFixed(2)} (${item.people.join(", ")})`;

/**
 * Component showing a list of dishes ordered.
 *
 * Clicking "X" also will remove a dish from the calculation.
 */
const ItemsSection: React.FC<ItemSectionProps> = ({
  dues,
  items,
  removeItem,
}) => (
  <div className="main-section">
    <h3 className="text-center mb-4">Items Ordered</h3>
    {dues.length === 0 && <NoOrder />}
    {items.map((item, index) => (
      <Card key={index}>
        <Card.Body>
          <div className="item">
            <span>{formatItem(item)}</span>
            <Button
              className="x-button"
              variant="outline-danger"
              onClick={() => removeItem(index)}
            >
              ✕
            </Button>
          </div>
        </Card.Body>
      </Card>
    ))}
  </div>
);

export default ItemsSection;
